export default "/images/2d63dfb4accaf2cb6f813d4e923c2333.avif";